<div class="row mt-2 d-flex" style="margin: 3em">
    <div class="col-xl-6">
        <div class="textSubtitle1" translate>INDUSTRY.CHOOSE_COUNTRY</div>
        <span style="font-style: italic; font-size: small" translate>INDUSTRY_CONFIGURATOR.COUNTRY_FIELD</span>
    </div>
    <div class="col-xl-6">
        <mat-form-field appearance="outline">
            <mat-select
                (selectionChange)="onCountryChange($event)"
                [value]="this.countryService?.countrySelected"
                [disabled]="this.isModifyStatus"
            >
                <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                <mat-option *ngFor="let c of this.isoCountryCodeList" [value]="c.ISOCountryCode">
                    {{ c.Description }} {{getFormattedInfo(c.LocalizationCompleted)}}
                </mat-option>
            </mat-select>
            <mat-hint>{{this.countrySelectionHint}}</mat-hint>
        </mat-form-field>

    </div>
</div>
